<template>
  <div class="callme_total_wrap hidden-xs-only">
    <!-- <div class="callme_top_wrap"></div> -->
    <div class="callme_bottom_wrap">
      <div class="bottom_container">
        <div class="warp">
          <div class="item_tit">
            <div class="header">
              <div class="imgs">
                <img src="@/assets/logox.png" alt="氢能" />
              </div>
              <div class="name">浙江省氢能装备制造业创新中心</div>
            </div>
          </div>
          <div class="item_options">
            <div class="desc">
              先进功能纤维的研发，知识产权运营，技术成果转化，技术服务、检测服务、可信平台
            </div>
          </div>
        </div>
        <div class="items_wrap">
          <div class="item_tit">产品</div>
          <div class="item_options">
            <span>企业大脑</span>
            <span>企业招商</span>
            <span>企业创新服务</span>
            <span>企业咨询</span>
          </div>
        </div>
        <div class="items_wrap">
          <div class="item_tit">内容中心</div>
          <div class="item_options">
            <span>行业报告</span>
            <span>精选文章</span>
            <span>媒体报道</span>
          </div>
        </div>
        <div class="items_wrap">
          <div class="item_tit">联系我们</div>
          <div class="item_options">
            <el-menu
              :default-active="activeIndex"
              class="el_menu_demo"
              mode="horizontal"
              background-color="#21282D"
              text-color="#8F9095"
              active-text-color="#8F9095"
              @select="handleSelect"
            >
              <el-menu-item index="1" class="el_menu_item">浙江</el-menu-item>
              <!-- <el-menu-item index="2" class="el_menu_item">成都</el-menu-item>
              <el-menu-item index="3" class="el_menu_item">北京</el-menu-item>
              <el-menu-item index="4" class="el_menu_item">重庆</el-menu-item> -->
            </el-menu>
            <div class="massage_show">
              <p>
                <i class="el-icon-phone icon"></i
                >{{ cityInfomation[showCity].phone }}
              </p>
              <p>
                <i class="el-icon-s-promotion icon"></i
                >{{ cityInfomation[showCity].eamil }}
              </p>
              <p>
                <i class="el-icon-location icon"></i
                >{{ cityInfomation[showCity].address }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="navigate_wrap">
        <span>友情链接:</span>
        <a href="http://www.gov.cn/">中华人民共和国中央人民政府</a>
        <a href="http://www.miit.gov.cn/">中华人民共和国工业和信息化部</a>
        <a href="https://www.fmprc.gov.cn/chn/gxh/tyb/">中华人民共和国外交部</a>
        <a href="http://www.tobacco.gov.cn/">国家烟草专卖局</a>
        <a href="http://www.cinn.cn/">中国工业新闻网</a>
        <p>
          Copyright ©2020 氢能 . All Rights Reserved . 津ICP备19007837号-7
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "1",
      cityInfomation: [
        {
          phone: "0000-00000000",
          eamil: "Contact@hsmap.com",
          address: "浙江省嘉兴市港区中山东路188号1幢701内710室",
        },
        {
          phone: "028-86713133",
          eamil: "Contact@hsmap.com",
          address: "成都市高新区天晖路360号晶科一号1806室",
        },
        {
          phone: "0571-86885326（转）",
          eamil: "Contact@hsmap.com",
          address: "北京市朝阳区安翔北里11号院北京创业大厦B座1005",
        },
        {
          phone: "15051586330",
          eamil: "Contact@hsmap.com",
          address: "重庆市九龙坡区华岩镇华锦路26号",
        },
      ],
      showCity: 0,
    };
  },
  methods: {
    handleSelect(index) {
      this.showCity = parseInt(index) - 1;
    },
    handleToRouter(url) {
      // this.$router.replace(url)
    },
  },
};
</script>

<style lang="scss" scoped>
.callme_total_wrap {
  width: 100%;
  margin-top: 40px;
  // .callme_top_wrap {
  //   width: 100%;
  //   height: 300px;
  //   background: url('../../assets/img/call.a455486.png') 0 0 no-repeat;
  //   background-size: 100% 100%;
  // }
  .callme_bottom_wrap {
    width: 100%;
    background: #21282d;
    color: #fff;
    padding-top: 70px;
    .bottom_container {
      width: 70%;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      padding-bottom: 60px;
      border-bottom: solid #363636 2px;
      .items_wrap {
        margin-right: 100px;
        .item_tit {
          font-size: 22px;
          .header {
            display: flex;
            align-items: center;
            .imgs {
              width: 70px;
            }
          }
        }
        .item_options {
          display: flex;
          flex-direction: column;
          width: 120px;
          span {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 16px;
            margin-top: 35px;
            cursor: pointer;
            &:hover {
              font-weight: bold;
            }
          }
          .el_menu_demo {
            border: none;
            background: none;
            margin-top: 10px;
            width: 300px;
            .el_menu_item {
              &:hover {
                font-weight: bold;
              }
            }
          }
          .massage_show {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 15px;
            width: 300px;
            height: 80px;
            .icon {
              margin-right: 10px;
            }
            p {
              margin-top: 30px;
            }
          }
          img {
            width: 100%;
            margin-top: 20px;
          }
        }
      }
      .warp {
        width: 400px;
        margin-right: 100px;
        .item_tit {
          font-size: 22px;
          .header {
            display: flex;
            align-items: center;
            .imgs {
              width: 70px;
              height: 100%;
              display: flex;
              align-items: center;
              margin-right: 10px;
            }
          }
        }
        .desc {
          padding: 0px 0px 0px 15px;
          font-size: 16px;
          color: hsla(0, 0%, 100%, 0.5);
          margin-top: 38px;
        }
      }
    }
    .navigate_wrap {
      width: 70%;
      margin: 0 auto;
      margin-top: 40px;
      padding-bottom: 15px;
      // word-break: keep-all;
      // word-wrap: break-word;
      display: flex;
      flex-wrap: wrap;
      a {
        color: hsla(0, 0%, 100%, 0.5);
        font-size: 16px;
        margin-right: 33px;
        text-decoration: none;
      }
      span {
        color: #fff;
        padding-right: 30px;
        font-size: 18px;
        margin-right: 0;
      }
      p {
        font-size: 16px;
        color: #4e5557;
      }
    }
  }
}
</style>